export default __webpack_public_path__ + "static/media/expired-error.7caf6742.png";